import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export const HeroSection = () => {
  return <SectionWrapper bg="bg-navy-900" className="pt-20 md:pt-32 pb-12 md:pb-20" data-id="element-47">
      <div className="text-center flex flex-col items-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-10 w-full max-w-lg mx-auto relative" data-id="element-49">
          {/* Decorative glow behind image */}
          <div className="absolute inset-0 bg-gold-500/20 blur-[100px] rounded-full z-0" data-id="element-50"></div>
          <img src="https://cdn.magicpatterns.com/uploads/cCr4h36jkRuYwBypRHVk7Y/tempImagewNlgrd.png" alt="El Sistema Blindado en Tablet" className="w-full h-auto relative z-10 drop-shadow-2xl" data-id="element-51" />
        </motion.div>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-52">
          El Sistema Blindado: <br className="hidden md:block" data-id="element-53" />
          <span className="text-gold-500" data-id="element-54">
            Limpia tu Crédito y Liquida Deudas
          </span>{' '}
          sin Abogados
        </h1>

        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-55">
          El método legal paso a paso para borrar reportes negativos en 30 días
          y recuperar tu poder financiero en los Estados Unidos.
        </p>

        <CTAButton data-id="element-56" />
      </div>
    </SectionWrapper>;
};